<template>
  <section class="kpi-row">
    <KpiCard 
      label="Сессии" 
      :value="currentStatistic?.total_sessions" 
      :delta="currentStatistic?.change_percent" 
      type="primary" 
    />
    <KpiCard 
      label="Заявки" 
      :value="currentStatistic?.conversions.total_applications" 
      :sub="'из ' + currentStatistic?.total_sessions + ' визитов'" 
    />
    <KpiCard 
      label="Конверсия" 
      :value="currentStatistic?.conversions.conversion_percent + '%'" 
      sub="заявки/посетители" 
    />
    <KpiCard 
      label="Среднее время на сайте" 
      :value="currentStatistic?.average_time_formatted + ' мин'" />
  </section>
</template>

<script>
import KpiCard from './kpi/KpiCard.vue';
export default {
  name: 'KpiRow',
  components: { KpiCard },
  props: ['stats', 'currentStatistic']
};
</script>

<style scoped>
.kpi-row{display:flex;gap:1rem;flex-wrap:nowrap; flex-direction: row;}
@media (max-width: 1024px) {
  .kpi-row {
    flex-wrap: wrap;
  }
}
</style>